<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="8">
        <p class="title">Profiles</p>
      </v-col>
    </v-row>
    <v-row v-if="requestLoading">
      <v-col cols="12" lg="8">
        <v-progress-circular
          :indeterminate="requestLoading"
          :value="requestProgress"
          color="yellow"
          class="mr-3"
        ></v-progress-circular>
        <span>{{ requestStatus }}</span>
        <v-alert
          class="mt-3"
          :value="outputAlert"
          type="error"
          transition="scale-transition"
        >
          {{ outputMessage }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="!requestLoading">
      <v-col cols="12" lg="8">
        <v-data-table
          :headers="dataTableHeaders"
          :items="armoryProfiles"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:item.battle_tag="{ item }">
            <div class="good3-tableProfile_name">
              <router-link :to="{ name: 'Profile', params: { profile_id: item.profile_id }}">{{ profileNameFromBattleTag(item.battle_tag) }}</router-link>
            </div>
            <div class="good3-tableProfile_battleTag">
              <a :href="item.web_url" target="_blank">
                <v-icon small class="blue--text darken-1">mdi-battlenet</v-icon>
                {{ item.battle_tag }}
                <v-icon size="11">launch</v-icon>
              </a>
            </div>
          </template>

          <template v-slot:item.parangon="{ item }">
            <div class="good3-chipsParangon indigo lighten-2">{{ item.parangon }}</div>
            <div class="good3-chipsParangon indigo lighten-2 good3-withAvatar">
              <v-icon size="13">mdi-leaf</v-icon>
              {{ item.parangon_sea }}
            </div>
            <div class="good3-chipsParangon indigo">{{ item.bonus.total_parangon_sc }}</div>
            <br>
            <div class="good3-chipsParangon good3-hc lighten-1">{{ item.parangon_hc }}</div>
            <div class="good3-chipsParangon good3-hc lighten-1 good3-withAvatar">
              <v-icon size="13">mdi-leaf</v-icon>
              {{ item.parangon_sea_hc }}
            </div>
            <div class="good3-chipsParangon good3-hc">{{ item.bonus.total_parangon_hc }}</div>
          </template>

          <template v-slot:item.heroes_number="{ item }">
            <v-icon size="13" class="mb-1">mdi-emoticon</v-icon> {{ item.bonus.nb_alive_heroes }} - {{ item.bonus.nb_dead_heroes }} <v-icon size="13" class="mb-1">mdi-skull-crossbones</v-icon><br>
            {{ item.bonus.nb_sea_heroes }} <v-icon size="13" class="green--text mb-1">mdi-leaf</v-icon><br>
            {{ item.bonus.nb_hc_heroes }} <v-icon size="13" class="mb-1">mdi-skull-crossbones</v-icon>
          </template>

          <template v-slot:item.last_updated="{ item }">
            {{ howLongAgo(item.last_updated) }}<br>
            <span class="fullDate">{{ humanDate(item.last_updated) }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// MIXINS
import { Good3Lib } from '../good3lib/good3_lib'
import { ProfileLib } from '../good3lib/profile_lib'

// VUEX
import { mapGetters } from 'vuex'

// DEFAULT
export default {
  name: 'GOOD3_PageDashboard',

  // Importing VUEJS shared resources
  //
  // • props for input
  // • components for sub vue components
  // • mixins for methods libraries
  props: {},
  components: {},
  mixins: [Good3Lib, ProfileLib],

  // Accessible properties
  //
  // • data
  // • computed
  // • watch
  data: () => ({
    // API calls variables
    requestLoading: false,
    requestProgress: 0,
    requestStatus: '',
    outputAlert: false,
    outputMessage: '',

    // Data Table properties
    dataTableHeaders: [
      { text: 'Profile', value: 'battle_tag', align: 'left', class: ['yellow--text', 'body-2'], width: '180px' },
      { text: 'Parangons', value: 'parangon', align: 'right', class: ['yellow--text', 'body-2'] },
      { text: 'Heroes', value: 'heroes_number', align: 'right', class: ['yellow--text', 'body-2'] },
      { text: 'Last Seen', value: 'last_updated', align: 'right', class: ['yellow--text', 'body-2'] }
    ]
  }),
  computed: {
    // FROM VUEX
    ...mapGetters([
      'armoryProfiles'
    ])
  },
  watch: {},

  // VUEJS lifecycle hooks
  //
  // • created
  // • mounted
  mounted () {
    // lets get the profiles and display them
    if (this.armoryProfiles === null) {
      this.loadProfiles()
    }
  },

  // Components methods
  methods: {}
}
</script>

<style scoped>
div.good3-tableProfile_name {
  height: 26px;
  line-height: 26px;
  font-size: 14px;
}

div.good3-tableProfile_name a {
  color: var(--blue_links);
  text-decoration: none;
}

div.good3-tableProfile_name a:hover {
  color: var(--blue_links);
  text-decoration: underline;
}

div.good3-tableProfile_battleTag {
  height: 19px;
  padding: 3px 0px 3px 0px;
  line-height: 13px;
  font-size: 10px;
}

div.good3-tableProfile_battleTag a {
  color: white;
  text-decoration: none;
}

div.good3-tableProfile_battleTag a:hover {
  color: white;
  text-decoration: none;
}

img.good3-blizzIcon {
  height: 13px;
  width: 20px;
  display: inline;
  vertical-align: sub;
}

span.fullDate {
  font-size: 10px;
}
</style>
